export default __webpack_public_path__ + "static/media/640_portfolio02-fr-web.30780030.png";